import { get, post } from '@/utils/request'

//预下单列表
export const getCartDetail = data => post('/clCartDetail/getCartDetail', data)

//保存预下单信息
export const saveCartDetail = data => post('/clCartDetail/saveOrUpdateCartDetail', data)

//删除预下单信息
export const deleteCartDetailByStatus = (ids) => post('/clCartDetail/deleteCartDetailByStatus', ids)

//获取预下单数量
export const getCartCount = () => get('/clCartDetail/getCartCount')

//获取预下单数量
export const deleteCartDetailOne = (id) => get('/clCartDetail/deleteCartDetailOne', {id:id})

//根据用户id和预下单id获取预下单信息
export const getPreOrderOne = data => post('/clCartDetail/getPreOrderOne', data)

//根据用户id和预下单id修改预下单信息
export const updateCartDetail = data => post('/clCartDetail/updateCartDetail', data)



// WEBPACK FOOTER //
// ./src/api/clCartDetail.js